import { render } from "./EntityBlock.vue?vue&type=template&id=5a1f35d2&ts=true"
import script from "./EntityBlock.vue?vue&type=script&lang=ts"
export * from "./EntityBlock.vue?vue&type=script&lang=ts"

import "./EntityBlock.vue?vue&type=style&index=0&id=5a1f35d2&lang=scss"

import exportComponent from "/Users/nicolacentonze/Desktop/Projects/cons-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__